import { useUnityActions } from "./unityActions";
import useApp from "./useApp";
import { useCoordinates } from "./useCoordinates";
import useData from "./useData";
import { useMinifiedMenu } from "./useMinifiedMenu";
import { usePins } from "./usePins";
import useScreen from "./useScreen";
import useSignalR from "./useSignalR";
import useUnity from "./UseUnity";
import { useDxfWidgets } from "./useDxfWidgets";
import useThemeColorPicker from "./useThemeColorPicker";
import { useAiChat } from "./AiChatContext";

const allHooks = {
  useApp,
  useData,
  useScreen,
  useSignalR,
  useCoordinates,
  useUnity,
  usePins,
  useMinifiedMenu,
  useUnityActions,
  useDxfWidgets,
  useThemeColorPicker,
  useAiChat
};

export default allHooks;